<template>
  <div>
    <button
      class="vactionbutton"
      :id="id"
      :class="{ pressed: isPressed }"
      data-test="vactionbutton"
      type="button"
      @click.passive="emitClick($event)"
      @keydown.esc="emitEsc($event)"
    >
      <slot name="icon">
        <object
          v-if="showIcon"
          type="image/svg+xml"
          style="pointer-events: none"
          :style="'fill:' + isPressed ? '#FFF' : '#000;'"
          :data="iconSrc"
        >
          {{ iconAlt }}
        </object>
      </slot>
      <slot name="label">
        <template v-if="showLabel">
          {{ label }}
        </template>
      </slot>
      <slot name="badge">
        <span
          v-if="showBadge"
          class="count"
          :class="{ 'zero-count': count === 0 }"
        >
          {{ count }}
        </span>
      </slot>
      <slot> </slot>
    </button>
  </div>
</template>
<script>
export default {
  name: "VActionButton",
  props: {
    id: {
      type: String,
      default: null,
    },
    count: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: "gear",
    },
    isPressed: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Text",
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    optionalHandler: {
      type: Function,
      required: false,
    },
    iconAlt: {
      type: String,
      default: "icon",
    },
  },
  data() {
    return {
      isCollapsed: false,
      showAdvanced: false,
      iconSrc: require(`./${this.icon}.svg`),
    };
  },
  methods: {
    emitClick($event) {
      this.$emit("click", $event);
      if (this.optionalHandler) this.optionalHandler();
    },
    emitEsc($event) {
      this.$emit("esc", $event);
    },
  },
};
</script>

<style scoped>
button {
  font-family: var(--font-system-ui, sans-serif);
  font-size: var(--font-size-75, 0.889rem);
  background: var(--gray-75, #fdfdfd);
  border: 1px solid var(--gray-500, #909090);
  /* Drop Shadow - Gray */
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  min-height: 2rem;
  min-width: min-content;
  max-width: max-content;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.75rem 0.125rem 0.75rem;
}

button:hover {
  /* Gray 200 */
  background: #e6e6e6;
  /* Drop Shadow - Gray */
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
}

button:active {
  /* Gray 300 */
  background: #d5d5d5;
  /* Drop Shadow - Gray Down */
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
}

button.pressed,
button.pressed:hover,
button.pressed:active {
  color: #fff;
  /* Gray 600 */
  background: #6d6d6d;
  /* Gray 700 */
  border: 1px solid #464646;
  /* Inner Shadow - Gray */
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.25);
}

span.count {
  margin-left: 0.125rem;
  padding: 0.125rem 0.25rem;
  background-color: var(--blue-900, #2964d4);
  color: var(--gray-50, #ffffff);
  border-radius: 20%;
}

span.zero-count {
  background-color: var(--gray-500, gray);
}
</style>
